import { Box, Flex, Heading, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { ObfuscateDataTab } from "../../components/obfuscate-data-tab/obfuscate-data-tab.comp";
import { DemoTenantTab } from "../../components/demo-tenant-tab/demo-tenant-tab.comp";

export function AdminActions() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Admin Actions</Heading>
            </Flex>
            <Tabs variant="enclosed" colorScheme="teal">
                <TabList>
                    <Tab>Obfuscate Data</Tab>
                    <Tab>Demo Tenant Data</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        <ObfuscateDataTab />
                    </TabPanel>
                    <TabPanel>
                        <DemoTenantTab />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}
